import { render } from "./TabelaPaginada.vue?vue&type=template&id=dc2b437e"
import script from "./TabelaPaginada.vue?vue&type=script&lang=js"
export * from "./TabelaPaginada.vue?vue&type=script&lang=js"

import "./TabelaPaginada.vue?vue&type=style&index=0&id=dc2b437e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__